import { MeetingAvailabilityService } from './meeting-availability.service';
import { MeetingTypeService } from './meeting-type.service';
import { ScheduledMeetingService } from './scheduled-meeting.service';
import { PushNotificationTokenService } from './push-notification-token.service';
import { MessageService } from './message.service';
import { ThreadService } from './thread.service';
import { OrderUpdateRequestService } from './order-update-request.service';
import { RefundItemService } from './refund-item.service';
import { InvoicePaymentService } from './invoice-payment.service';
import { InvoiceItemService } from './invoice-item.service';
import { InvoiceService } from './invoice.service';
import { OrderCardServiceLinkageService } from './order-card-service-linkage.service';
import { ActionLogService } from './action-log.service';
import { AuthService } from './auth.service';
import { CardAttributeDetectionService } from './card-attribute-detection.service';
import { CustomerProfileService } from './customer-profile.service';
import { OfferedServiceService } from './offered-service.service';
import { OrderCardAttributeTypeService } from './order-card-attribute-type.service';
import { OrderCardAttributeService } from './order-card-attribute.service';
import { OrderCardService } from './order-card.service';
import { OrderServiceLinkageService } from './order-service-linkage.service';
import { OrderSourceService } from './order-source.service';
import { OrderStatusService } from './order-status.service';
import { OrderService } from './order.service';
import { PaymentService } from './payment.service';
import { RefreshTokenService } from './refresh-token.service';
import { StaffProfileService } from './staff-profile.service';
import { StorageService } from './storage.service';
import { UserRoleAssignmentService } from './user-role-assignment.service';
import { UserRoleService } from './user-role.service';
import { UserService } from './user.service';
import { ChatService } from './chat.service';
import { FunctionService } from './function.service';

export const angularCoreServices = [
  AuthService,
  CardAttributeDetectionService,
  StorageService,
  PaymentService,
  ChatService,
  FunctionService,
  OrderService,
  OrderCardService,
  UserService,
  UserRoleService,
  UserRoleAssignmentService,
  RefreshTokenService,
  ActionLogService,
  OfferedServiceService,
  OrderServiceLinkageService,
  OrderSourceService,
  OrderStatusService,
  OrderCardAttributeService,
  OrderCardAttributeTypeService,
  CustomerProfileService,
  StaffProfileService,
  OrderCardServiceLinkageService,
  InvoiceService,
  InvoiceItemService,
  InvoicePaymentService,
  RefundItemService,
  OrderUpdateRequestService,
  ThreadService,
  MessageService,
  PushNotificationTokenService,
  ScheduledMeetingService,
  MeetingTypeService,
  MeetingAvailabilityService,
];
